.BgDark
    background: rgb($globalSettingsBackgroundSecondary)

.BgWhite
    background: rgb($globalSettingsBackgroundPrimary)

.ArticleBookingContainer
    display: block
    min-height: 0
    min-width: 310px
    max-width: 100%

.ArticleBookingContainerSlots
    display: block
    min-height: 0
    min-width: 340px
    max-width: 100%

.CalendarTemplateContainerDimensions
    display: block
    position: relative
    min-height: 0
    width: 340px
    max-width: 100%

.CalendarTemplateContainer
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    background-color: rgb($globalSettingsBackgroundPrimary) !important
    border-radius: $globalSettingsRounding
    display: flex
    flex-direction: column
    box-sizing: border-box
    margin: 0
    padding: 20px 20px 10px
    overflow: visible
    box-shadow: $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05)

.DateContainer
    width: 100%
    font-size: 12px
    svg
        margin: 0 10px
        stroke: rgb($globalSettingsFontSecondary)

.BottomContainer
    width: calc( 100% + 42px )
    margin-left: -21px
    margin-right: -21px
    margin-bottom: -21px
    padding: 20px 20px 10px 20px
    box-sizing: border-box
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    border-radius: $globalSettingsRounding

.NotAvailableContainer
    width: 100%
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    padding: 10px 15px
    background: rgb($globalSettingsBackgroundTertiary)
    border-radius: $globalSettingsRounding
    box-sizing: border-box
    stroke: rgb($globalSettingsFontSecondary)

.NotAvailableContainerInner
    width: 100%
    display: flex
    flex-direction: column
    box-sizing: border-box
    margin-left: 10px
    justify-content: center
    align-items: center
    .Title
        font-weight: 700
        margin-bottom: 2px
    span
        text-align: center

.BookingMessage
    width: 100%

.PickersContainer
    max-width: 100%
    width: 100%
    display: flex
    flex-direction: row
    justify-content: space-between
    gap: 20px
    .PickerContainer
        min-width: 0
        max-width: 100%
        flex: 1
